import { useRoutes } from "react-router";
import { underMaintanceRoutesV6 } from "./Routes";

const UnderMaintananceRoute = () => {
  let renderUnderMaintananceRoutes = useRoutes(underMaintanceRoutesV6);
  return <>{renderUnderMaintananceRoutes}</>;
};

export default UnderMaintananceRoute;
